import { Chart } from 'chart.js';
import { PosServiceProvider } from './../../providers/pos-service/pos-service';
import { AuthProvider } from './../../providers/auth/auth';
import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Loading } from 'ionic-angular';
import { GlobalProvider } from '../../providers/global/global';
/**
 * Generated class for the PosTablePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-pos-table',
  templateUrl: 'pos-table.html',
})
export class PosTablePage {
  @ViewChild('pieChart') pieChart;
  trans_count = [];
  trans_countprev = [];
  list_date = [];
  list_date_labels = [];
  listdiv = [];
  public pieChartEl: any;

  dashgroup: {};
  dash: {};
  dash2: {};
  outletlist: any[] = [];
  loading: Loading;
  name = '';
  username = '';
  serverlocation = '';
  token = '';
  userid = '';
  kodediv = '';
  namadiv = '';
  groupid = 0;
  outlet : any;

  constructor(public navCtrl: NavController, public navParams: NavParams, private auth: AuthProvider,
    private posservice: PosServiceProvider, private loadingCtrl: LoadingController, private global: GlobalProvider) {
      let info = this.auth.getUserInfo();
      this.name = info.name;
      this.username = info.username;
      this.serverlocation = info.serverlocation;
      this.userid = info.userid;
      this.token = info.token;
      //this.loadChart();
      this.loadOutlet();
  }
  public loadChart()
  {
    this.showLoading();
    this.posservice.loadPOSChart(this.userid, this.token, this.serverlocation,this.global.ICNO)
      .then(data => {
        this.dash2 = data;
        let k : any;

        //Reset
        this.list_date = [];
        this.list_date_labels = [];
        this.listdiv = [];

        let dateSet = new Set();
        let divSet = new Set();
        let divData = {};

        for(k in this.dash2)
        {
          let namaDiv = this.dash2[k]['NamaDiv'];
          let tanggal = this.dash2[k]['Tanggal'];
          let revenue = Number(this.dash2[k]['Revenue']);

          dateSet.add(tanggal);
          divSet.add(namaDiv);

          if (!divData[namaDiv]) {
            divData[namaDiv] = {};
          }
          divData[namaDiv][tanggal] = revenue;
        }

        this.list_date = Array.from(dateSet).sort();
        this.list_date_labels = this.list_date.map(d => {
          let dt = new Date(d);
          return ('0' + dt.getDate()).slice(-2);
        });

        let colors = [
          'rgb(54, 162, 235)',
          'rgb(255, 159, 64)',
          'rgb(153, 102, 255)',
          'rgb(75, 192, 192)',
          'rgb(255, 99, 132)',
          'rgb(255, 205, 86)',
          'rgb(201, 203, 207)',
        ];

        let datasets = [];
        let colorIndex = 0;

        divSet.forEach(namaDiv => {
          let dataPoints = this.list_date.map(d => divData[namaDiv][d] || 0);
          this.listdiv.push(namaDiv);
          let c = colors[colorIndex % colors.length];
          datasets.push({
            label: namaDiv,
            data: dataPoints,
            borderColor: c,
            backgroundColor: c.replace('rgb', 'rgba').replace(')', ', 0.2)'),
            fill: false,
            tension: 0.1,
            pointRadius: 3
          });
          colorIndex++;
        });

        this.createLineChart(datasets);
        this.loading.dismiss();
      });
  }

  public loadGroup() {
    this.showLoading();
    this.posservice.loadPOSDashboardGroup(this.userid, this.token, this.serverlocation, this.kodediv)
    .then(data => {
      this.dashgroup = data;
      this.loading.dismiss();
    });
  }

  public groupselected(itm) {
    this.groupid = itm.GroupID;
    this.loadData();
  }
  public loadData() {
    this.showLoading();

    this.posservice.loadPOSDashboard(this.userid, this.token, this.serverlocation, this.kodediv, this.groupid)
    .then(data => {
      this.dash = data;      
      this.loading.dismiss();
    });
  }

  getTotal() {
    let total = 0;
    let m =0;
    for(let key in this.dashgroup){
      let j = this.dashgroup[m].Total;
      total += Number(j.toString().replace(/,/g, ''));
      m++;
    }
    return total;
  }
  getTotalUse() {
    let total = 0;
    let m =0;
    for(let key in this.dashgroup){
      let j = this.dashgroup[m].InUse;
      total += Number(j.toString().replace(/,/g, ''));
      m++;
    }
    return total;
  }
  getTotalAvail() {
    let total = 0;
    let m =0;
    for(let key in this.dashgroup){
      let j = this.dashgroup[m].Available;
      total += Number(j.toString().replace(/,/g, ''));
      m++;
    }
    return total;
  }

  createLineChart(datasets){
    if(this.pieChartEl) {
      this.pieChartEl.chart.destroy();
    }
    this.pieChartEl = new Chart(this.pieChart.nativeElement,
      {
         type: 'line',
         data: {
             labels: this.list_date_labels,
             datasets: datasets
         },
         options : {
              maintainAspectRatio: false,
              legend         : {
                display     : true
              },
              tooltips:{
                callbacks: {
                  label: function(tooltipItem, data) {
                      let label = data.datasets[tooltipItem.datasetIndex].label || '';
                      let value = Number(tooltipItem.yLabel).toFixed(0).replace(/./g, function(c, i, a) {
                          return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
                      });
                      return label + ': ' + value;
                  }
                }
              },
              title: {
                display: true,
                text: 'Revenue by Division'
              },
              scales: {
                  yAxes: [{
                      ticks: {
                        beginAtZero:true,
                        callback: function(label, index, labels) {
                          return Number(label).toFixed(0).replace(/./g, function(c, i, a) {
                              return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
                          });
                        }
                      }
                  }],
                  xAxes: [{
                      ticks: {
                        autoSkip: false
                      }
                  }]
              }
          }
      });
  }

  loadOutlet() {
    this.posservice.loadOutlet(this.userid, this.token, this.serverlocation, this.global.ICNO)
    .then(data => {
      this.outletlist = <any[]>data;
      console.log('outlet:'+this.outletlist);
    });
  }
  public optionsFn() {
      let item = this.outlet;
      let itm = item.toString(); //.split(":");
      let it = itm.split(":");
      this.kodediv = it[0];
      this.namadiv = it[1];
      this.dash = null;
      this.loadGroup();
  }
  showLoading() {
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  doRefresh(refresher) {
    console.log('Begin async operation', refresher);
    this.loadGroup();
    setTimeout(() => {
      console.log('Async operation has ended');
      refresher.complete();
    }, 2000);
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad PosTablePage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/pos-table/pos-table.ts